// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2IK49","signatureBlock":"Footer_signatureBlock__vdBV8","signature":"Footer_signature__2LDtZ"};